export const formatCurrency = (value) => {
  if (isNaN(value)) return '-'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    // show decimals only if needed
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
  }).format(value)
}
